<template>
	<div
		class="preloader fixed inset-0 z-50 flex items-center justify-center bg-white"
		ref="preloader"
	>
		<div class="logo-container w-32 md:w-48">
			<svg
				viewBox="0 0 1500 1358"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				ref="logo"
				class="opacity-0"
			>
				<path
					d="M165 491.431C314.567 490.432 386.25 491.431 386.25 491.431C386.25 491.431 372.775 536.597 362.827 558.545C350.22 586.371 333.312 614.059 303.091 656.359C244.373 738.549 207.008 818.995 196.208 886.512C190.836 920.1 191.765 1004.02 197.864 1036.16C219.157 1148.43 279.624 1238.13 382.551 1310.14C412.776 1331.28 417.611 1335.98 417.612 1344.17V1358H210C3.75 1358 0 1356.16 0 1349.43C0.000208271 1343.59 3.18446 1337.91 22.1558 1335.58C64.3808 1330.4 91.0037 1312.53 107.043 1278.62L115.906 1259.86L116.038 1002.44C116.106 860.853 115.337 705.88 114.331 658.059C112.633 577.417 111.971 570.125 105.146 557.475C91.1731 531.577 63.2062 512.904 33.252 509.462C5.31913 506.254 1.70687 504.915 1.70654 497.776C1.70654 491.195 3.75 491.431 165 491.431Z"
					fill="black"
					stroke="black"
					stroke-width="5"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M1198.31 377.622C1198.33 960.984 1201.25 1256.05 1207.21 1277.75C1216.83 1312.81 1242.89 1331.97 1286.3 1335.91C1309.44 1338.01 1312.5 1340.72 1312.5 1346.75V1358H967.5V1195.25C964.574 1198.95 960.881 1205.3 956.213 1213.84C913.863 1291.34 855.952 1330.83 777.275 1351.55C748.289 1359.19 665.863 1360.3 634.094 1353.49C498.484 1324.41 410.461 1251.27 363.699 1113.25C335.144 1028.98 329.197 918.91 348.127 825.135C355.921 786.521 378.173 722.559 395.361 689.36C424.697 632.713 477.532 572.122 526.721 538.711C591.582 494.66 680.579 470.305 759.529 475.004C830.682 479.235 892.95 505.07 951.504 554.662C961.08 562.773 966.297 566.458 967.5 566.458V195.072C967.5 157.558 942.295 130.155 915.908 118.483C907.783 114.89 889.76 111.089 875.852 110.036C852.109 108.242 850.569 107.635 850.569 100.093C850.569 92.7867 852.032 92.0616 866.763 92.048C902.167 92.0168 997.938 72.0661 1063.18 51.1345C1081.68 45.1982 1115.26 31.2625 1137.8 20.171C1160.33 9.07623 1183.17 0 1188.54 0H1198.29L1198.31 377.622ZM796.436 499.3C771.276 493.968 764.907 493.857 738.479 498.245C712.553 502.554 682.786 519.583 662.073 541.964C597.508 611.736 563.134 781.654 571.663 988.884C579.585 1181.4 621.707 1293.08 699.968 1329.04C727.715 1341.78 768.862 1343.52 799.431 1333.24C873.766 1308.24 925.966 1245.59 954.309 1147.35C967.502 1098.09 967.401 1031.53 967.5 911.585C967.599 793.246 967.497 721.229 957.883 685.337C942.985 623.729 909.266 564.294 872.725 535.231C852.42 519.087 821.859 504.69 796.436 499.3ZM1050 1245.46C1033.43 1245.46 1020 1258.89 1020 1275.47C1020 1292.04 1033.43 1305.48 1050 1305.48H1125C1141.57 1305.48 1155 1292.04 1155 1275.47C1155 1258.89 1141.57 1245.46 1125 1245.46H1050ZM1050 1132.92C1033.43 1132.92 1020 1146.35 1020 1162.93C1020 1179.5 1033.43 1192.94 1050 1192.94H1125C1141.57 1192.94 1155 1179.5 1155 1162.93C1155 1146.35 1141.57 1132.92 1125 1132.92H1050ZM1050 1020.38C1033.43 1020.38 1020 1033.81 1020 1050.39C1020 1066.96 1033.43 1080.4 1050 1080.4H1125C1141.57 1080.4 1155 1066.96 1155 1050.39C1155 1033.81 1141.57 1020.38 1125 1020.38H1050ZM1050 907.834C1033.43 907.834 1020 921.27 1020 937.845C1020 954.419 1033.43 967.856 1050 967.856H1125C1141.57 967.856 1155 954.419 1155 937.845C1155 921.27 1141.57 907.834 1125 907.834H1050ZM1050 795.292C1033.43 795.292 1020 808.729 1020 825.303C1020 841.878 1033.43 855.314 1050 855.314H1125C1141.57 855.314 1155 841.878 1155 825.303C1155 808.729 1141.57 795.292 1125 795.292H1050ZM1050 682.751C1033.43 682.751 1020 696.187 1020 712.762C1020 729.337 1033.43 742.773 1050 742.773H1125C1141.57 742.773 1155 729.337 1155 712.762C1155 696.187 1141.57 682.751 1125 682.751H1050ZM1050 570.21C1033.43 570.21 1020 583.646 1020 600.221C1020 616.795 1033.43 630.232 1050 630.232H1125C1141.57 630.232 1155 616.795 1155 600.221C1155 583.646 1141.57 570.21 1125 570.21H1050ZM1050 457.668C1033.43 457.668 1020 471.105 1020 487.679C1020 504.254 1033.43 517.69 1050 517.69H1125C1141.57 517.69 1155 504.254 1155 487.679C1155 471.105 1141.57 457.668 1125 457.668H1050ZM1050 345.127C1033.43 345.127 1020 358.563 1020 375.138C1020 391.713 1033.43 405.149 1050 405.149H1125C1141.57 405.149 1155 391.713 1155 375.138C1155 358.563 1141.57 345.127 1125 345.127H1050ZM1050 232.585C1033.43 232.585 1020 246.022 1020 262.597C1020 279.171 1033.43 292.608 1050 292.608H1125C1141.57 292.608 1155 279.171 1155 262.597C1155 246.022 1141.57 232.585 1125 232.585H1050ZM1050 120.044C1033.43 120.044 1020 133.481 1020 150.055C1020 166.63 1033.43 180.066 1050 180.066H1125C1141.57 180.066 1155 166.63 1155 150.055C1155 133.481 1141.57 120.044 1125 120.044H1050Z"
					fill="black"
					stroke="black"
					stroke-width="5"
				/>
				<path
					d="M1413.75 1185.44C1461.38 1185.44 1500 1224.07 1500 1271.72C1500 1319.37 1461.38 1358 1413.75 1358C1366.12 1358 1327.5 1319.37 1327.5 1271.72C1327.5 1224.07 1366.12 1185.44 1413.75 1185.44Z"
					fill="black"
					stroke="black"
					stroke-width="5"
				/>
				<path
					d="M198.062 105.676C260.661 85.6807 332.498 115.618 358.564 172.563C392.26 246.178 364.223 325.018 292.236 359.07C271.541 368.859 266.342 369.888 238.638 369.643C203.6 369.332 186.474 364.127 159.346 345.552C138.489 331.269 119.789 307.257 109.893 282.042C100.215 257.388 100.215 213.148 109.893 188.492C125.332 149.162 158.008 118.472 198.062 105.676Z"
					fill="black"
					stroke="black"
					stroke-width="5"
				/>
			</svg>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';
import { usePreloaderState } from '~/composables/usePreloaderState';

const preloader = ref(null);
const logo = ref(null);
const { isFinished } = usePreloaderState();

onMounted(() => {
	// app.vue has already decided that the preloader should run.
	// This component's only job is to run the animation and update the state.
	const paths = logo.value.querySelectorAll('path');
	const tl = gsap.timeline({
		onComplete: () => {
			isFinished.value = true;
			sessionStorage.setItem('preloaderPlayed', 'true');
		},
	});

	// Initial state
	tl.set(logo.value, { opacity: 1 });
	tl.set(paths, {
		opacity: 0,
		scale: 0.9,
		transformOrigin: 'center center',
	});

	// Staggered fade-in and scale-up animation
	tl.to(
		paths,
		{
			opacity: 1,
			scale: 1,
			duration: 0.8,
			ease: 'power2.out',
			stagger: 0.1,
		},
		'+=0.2'
	);

	// Fade out the preloader
	tl.to(
		preloader.value,
		{
			duration: 0.8,
			opacity: 0,
			ease: 'power2.inOut',
		},
		'+=0.5'
	);
});
</script>
